import { defaultFormatter } from "./object";
import { sortByLabelAsc } from "./sortByProp";

type SelectValue = string | number | boolean;
type SelectOption<TValue = SelectValue> = {
  label: TValue;
  value: TValue;
};
type ModelLike = {
  id: string | number;
  name: string;
};

export function arrayToSelectOptions<TValue extends SelectValue>(
  arr: Array<TValue | null | undefined>,
): Array<SelectOption<TValue>> {
  const options = arr
    .filter((value): value is TValue => Boolean(value))
    .map((value) => {
      return { label: value, value };
    });

  return options.sort(sortByLabelAsc);
}

export function getBooleanOptions() {
  return [
    { label: "True", value: true },
    { label: "False", value: false },
  ];
}

/*
 * Find a select option from an array of options. If the option is not
 * found return the value as the option.
 *
 * @param options Array of select options.
 * @param value Select option value.
 * @returns {{label: *, value: *}} A Select Object.
 */
export function getOpt<TValue>(
  options: Array<{ label: TValue; value: TValue }> | null | undefined,
  value: TValue,
) {
  // In case options is null.
  const opt = (options || []).find((o) => o.value === value);
  if (opt) {
    return opt;
  }

  return {
    label: value,
    value,
  };
}

export function modelsToSelectOptions<T extends ModelLike>(
  models: Record<string, T> | T[],
  formatter: (model: T) => string = defaultFormatter,
) {
  return Object.values(models)
    .map((model) => ({ value: model.id, label: formatter(model) }))
    .sort(sortByLabelAsc);
}
